module.exports = __webpack_public_path__ + "static/media/LS027B7DH01 Spec (LD-28305A).260b22b4.pdf";